import React, { useState } from 'react';
import { Form, Input, Checkbox, Alert } from 'antd';
import { useSelector } from 'react-redux';
import { useSetModalVisible } from '../../../../model/modalState';
import BaseModal from '../../../BaseModal/BaseModal';
import { fieldNames } from './constants';
import { useSubmit } from '../../../../api';
import InformationBlockModal from '../../../InformationBlockModal/InformationBlockModal';
import { typeMassActionsText } from '../../../InformationBlockModal/constants';

const { TextArea } = Input;
const { Item: FormItem, create: createForm } = Form;

const Container = ({ form, requests, onSuccess }) => {
  const { getFieldDecorator, validateFields, resetFields } = form;

  const defaulCommentVisibility = useSelector(
    (store) => store.authentication.userInfo.DefaultCommentVisibility
  );

  const setModalVisible = useSetModalVisible();
   const [stateInfo, setStateInfo] = useState(false);
  const [value, setValue] = useState(null)

  const { submitAsync, loading } = useSubmit({
      url: 'Request/add_note',
      errMsg: 'Не удалось добавить комментарий у выбранных заявок',
      onSuccess,
    });

  const handleSubmit = (e) => {
    e.preventDefault();

    validateFields((err, values) => {
      if (!err) {
        const value = {
          Note: values.note,
          AvailableForClient: values.availableForClient,
        };

        setValue(value);
        setStateInfo(true);
      }
    });
  };

  const handleConfirmSubmit = async (e) => {
    e.preventDefault()

    try {
      await submitAsync({
        ids: requests.map(({ id }) => id),
        value,
        requests,
      });

      setModalVisible(false);
      setStateInfo(false);
      resetFields();
    } catch(error) {
      return <Alert title={error.message} />
    }
  }

  const cancelSubmit = () => {
    setStateInfo(false);
    resetFields()
  }

  return (
    <BaseModal
      onOk={stateInfo ? handleConfirmSubmit : handleSubmit}
      title={stateInfo ? "Подтвердите добавление" : "Добавление комментария"}
      onCancel={cancelSubmit}
      width={stateInfo ? 600 : 450}
      confirmLoading={loading}
    >
      {!stateInfo ? (
      <Form>
        <FormItem label="Комментарий">
          {getFieldDecorator(fieldNames.note, {
            initialValue: '',
            rules: [
              {
                required: true,
                whitespace: true,
                message: 'Напишите комментарий',
              },
            ],
          })(<TextArea autoSize={{ minRows: 2, maxRows: 5 }} />)}
        </FormItem>

        <FormItem>
          {getFieldDecorator(fieldNames.availableForClient, {
            valuePropName: 'checked',
            initialValue: defaulCommentVisibility,
          })(<Checkbox>Показывать собственнику</Checkbox>)}
        </FormItem>
      </Form>
       ) : (
        <InformationBlockModal typeMassActions={typeMassActionsText.addComment} count={requests.length} />
      )}
    </BaseModal>
  );
};

const AddComment = createForm({
  name: 'mass_actions_comment',
})(Container);

export default AddComment;
